<template>
  <v-row justify="center">
    <v-dialog
      v-model="selectCompanion"
      :persistent='true'
      width="20%"
      height="100%"
      class="modalDialog"
      no-click-animation
    >
      <div class="memberAdd">
        <v-card class="cardWrap">
          <CardTitle title="同伴者リスト" />
          <div class="p-4">
            <div>
              <div v-for="item in companionPlayerSelectList" :key="item.id">
                <v-checkbox
                :label="item.family_name + ' ' + item.given_name"
                v-bind:false-value="null"
                v-bind:true-value="item"
                @change="selectPlayer(item)"
                />
              </div>
            </div>
            <p v-if="alertError == false">{{count}}名まで選択可能となっています</p>
            <v-row>
              <v-btn color="primary" text @click="ClickEvent">登録</v-btn>
              <v-btn color="primary" text @click="OnClose">閉じる</v-btn>
            </v-row>
          </div>
        </v-card>
        <ChangeOverlay
          page-name="同伴者リスト"
          @cancel="changeOverlay = !changeOverlay"
          :process-result="process"
          :OverlaySwitch="changeOverlay"
        />
      </div>
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import ChangeOverlay from '@/views/Master/page/overlay/ChangeOverlay';
import { GET_COMPANION_LIST } from '../../../constants/companion';
import { CODE_MASTER } from '../../config';

export default {
    components: {
        CardTitle,
        ChangeOverlay
    },
    data () {
        return {
            // 選択されたmember_no
            selectedCompanionPlayers: [],
            selectCompanion: false,
            changeOverlay: false,
            // 友達リスト
            companionPlayerSelectList: [],
            count: null,
            alertError: true,
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            select: [],
            loadingCount: 0,
            index: 0
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.loadingCount = 0;
        },
        /** ----------------------------------------------
        * 同伴者一覧取得
        * 現在の予約に対する登録同伴者の一覧を取得する
        * @param loginUserMemberNo 代表者会員番号
        * ---------------------------------------------- */
        GetCompanionList: async function (reserveNo, loginUserMemberNo, count, index, representative, selectedPlayer) {
            var me = this;
            me.loadingOn();
            this.selectedCompanionPlayers = [];
            this.$apollo.query({
                query: GET_COMPANION_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    reserve_no: reserveNo,
                    cell_id: null
                }
            }).then(res => {
                var companionLists = res.data.GetCompanionListFromAdmin.CompanionLists;
                // 代表者監視用フラグ
                var check = false;
                // 表示用の連想配列を作成する
                me.companionPlayerSelectList = [];
                for (var i = 0; i < companionLists.length; i++) {
                    // 代表者がいたらチェックをしておく
                    if (companionLists[i].member_no &&
                        companionLists[i].member_no === loginUserMemberNo) {
                        check = true;
                    }
                    companionLists[i].id = companionLists[i].class_no.toString() +
                            '-' +
                            companionLists[i].player_no.toString();
                    const familyName = companionLists[i].family_name;
                    const givenName = companionLists[i].given_name;
                    const fullName = familyName + givenName;
                    const email = companionLists[i].email;
                    const selectedIndex = selectedPlayer.findIndex(selected => {
                        const selectedFullName = selected['family_name'] + selected['given_name'];
                        const selectedEmail = selected['email'];
                        if (selectedEmail) {
                            return email === selectedEmail;
                        }
                        return selectedFullName === fullName;
                    });
                    if (selectedIndex === -1) {
                        me.companionPlayerSelectList.push(companionLists[i]);
                    }
                }
                // 代表者がいなかったら代表者をリストに追加する
                if (!check) {
                    var player = {
                        reserve_no: reserveNo,
                        family_name: representative.family_name,
                        given_name: representative.given_name,
                        email: representative.email,
                        mobile_number: representative.mobile_number,
                        gender: representative.gender,
                        era: representative.era,
                        profile: representative.profile,
                        score_level: representative.score_level,
                        enthusiasm: null,
                        visited_code: 0,
                        member_no: loginUserMemberNo
                    };
                    // cell.cell_delete_Disable = true;
                    // 会員区分がなかったらビジターにする
                    if (!representative.member_class) {
                        player.member_class = CODE_MASTER.MEMBER_CLASS_VISITOR;
                    } else {
                        player.member_class = me.representative.member_class;
                    }
                    me.companionPlayerSelectList.unshift(player);
                }
                this.index = index;
                this.count = count;
                me.loadingOff();
            }).catch(error => {
                me.error = error;
                me.loadingOff();
            });
        },
        /** ----------------------------------------------
        * 選択されたプレーヤーの配列を切り替える
        * ---------------------------------------------- */
        selectPlayer (item) {
            if (this.selectedCompanionPlayers.length >= 1) {
                if (this.selectedCompanionPlayers.some(function (el, index) { return el === item; })) {
                    this.selectedCompanionPlayers.forEach((el, index) => {
                        if (el === item) {
                            this.selectedCompanionPlayers.splice(index, 1);
                        }
                    });
                } else {
                    this.selectedCompanionPlayers.push(item);
                }
            } else {
                this.selectedCompanionPlayers.push(item);
            }
        },
        /** ----------------------------------------------
         * 登録ボタン押下
         * ---------------------------------------------- */
        ClickEvent () {
            // 入力欄が空欄の人数より選択された人数の方が多い場合
            if (this.count < this.selectedCompanionPlayers.length) {
                this.process.result = 1;
                this.process.resultText = this.count + '名まで選択可能です。';
                this.changeOverlay = true;
            // 選択された人数が適正の場合
            } else if (this.count >= this.selectedCompanionPlayers.length && this.selectedCompanionPlayers.length >= 1) {
                this.alertError = true;
                for (var i = 0; i < this.selectedCompanionPlayers.length; i++) {
                    this.selectedCompanionPlayers[i].selectFlag = true;
                }
                this.$emit('select-companion', this.selectedCompanionPlayers, this.index);
                this.companionPlayerSelectList = [];
                this.selectedCompanionPlayers = [];
                this.selectCompanion = false;
            // 誰も選択されなかったら
            } else if (this.selectedCompanionPlayers.length < 1) {
                this.alertError = true;
                this.$emit('select-companion', this.selectedCompanionPlayers, this.index);
                this.companionPlayerSelectList = [];
                this.selectedCompanionPlayers = [];
                this.selectCompanion = false;
            }
        },
        /** ----------------------------------------------
         * ✖ボタン押下
         * ---------------------------------------------- */
        OnClose () {
            this.companionPlayerSelectList = [];
            this.selectedCompanionPlayers = [];
            this.alertError = true;
            this.selectCompanion = false;
            this.$emit('close-select-companion');
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function () {
            this.loadingCount--;
            if (this.loadingCount === 0) {
                this.selectCompanion = true;
            }
        }
    }
};
</script>

<style scoped>
</style>
